/**
 * Streaming type
 */
export const streamingTypes = {
  DASH_H264: 4,
  DASH_H265: 3
};

/**
 * Type of transparent catchup provider
 */
export const transparentProvider = {
  None: 0,
  HBO: 1,
  Fox: 2,
  FoxQuickPlay: 3
};

export const coverImagesTypes = {
  PortraitArt: 'PortraitAr',
  OriginalCover: 'OriginalCover',
  Cover: 'Cover',
  LandscapeCover: 'LandscapeCover',
  LandscapeWideCover: 'LandscapeWideCover',
  VideoFrame: 'VideoFrame',
  Banner: 'Banner'
};

/**
 * Type of items
 */
export const itemTypes = {
  MOV: 1,
  EPI: 2,
  LCH: 64,
  LSC: 128,
  REC: 256
};

/**
 * Live commercialization types
 */
export const commercializationTypes = {
  vspp: 6,
  cdn: 0,
  avod: 8
};

export const resolution4K = {
  width: 3840,
  height: 2160
};

export const quality = {
  Unknown: 0,
  HighDefinitionFull: 1,
  HighDefinition: 2,
  StandardDefinition: 3,
  LowDefinition: 4
};
